import axios from "axios";
export const DOMAIN = process.env.REACT_APP_BACKEND_DOMAIN;
export const API_URL = DOMAIN + "/wods/";

export const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
});

api.interceptors.request.use(async (config) => {
  document.cookie.split(";").map((item) => {
    if (item.includes("csrftoken")) {
      config.headers["X-CSRFToken"] = item.split("=")[1];
    }
  });
  config.headers["Content-Type"] = "application/json";
  return config;
});
